<template>
  <q-card class="q-pa-md">
    <p
      class="text-h6 text-bold"
      :class="this.$q.dark.mode === true ? '' : 'text-primary '"
    >
      Announcement
    </p>
    <div v-if="announcementList.length">
      <q-list v-for="item in announcementList" :key="item">
        <div class="cursor-pointer" @click="showDialog(item)">
          <q-item>
            <q-item-section side top>
              <q-icon
                name="star"
                size="xs"
                :color="this.$q.dark.mode === true ? '' : 'text-primary '"
              />
            </q-item-section>

            <q-item-section side top>
              <q-item-label caption>{{
                item.created_at.split("T")[0]
              }}</q-item-label>
            </q-item-section>

            <q-item-section>
              <q-item-label>{{ item.title }}</q-item-label>
              <q-item-label caption lines="2">{{ item.message }}</q-item-label>
            </q-item-section>
          </q-item>
        </div>
      </q-list>
      <q-dialog v-model="dialogAnnouncement" square>
        <q-card style="max-width: 95vh">
          <q-card-section
            :class="
              this.$q.dark.mode === true ? 'bg-grey-9' : 'bg-primary text-white'
            "
          >
            <q-bar
              :class="
                this.$q.dark.mode === true
                  ? 'bg-grey-9'
                  : 'bg-primary text-white'
              "
              style="min-height: 5vh"
            >
              <div class="text-h6">Announcement</div>
              <q-space></q-space>
              <q-btn
                class="q-px-xs q-mx-sm"
                v-close-popup
                text-color="white"
                color="red"
                dense
                size="sm"
                icon="close"
                @click="closeDialog"
              >
                <q-tooltip class="bg-white text-primary">Close</q-tooltip>
              </q-btn>
            </q-bar>
          </q-card-section>
          <q-card-section>
            <q-item>
              <q-item-section side top>
                <q-icon
                  name="star"
                  size="xs"
                  :color="this.$q.dark.mode === true ? '' : 'primary'"
                />
              </q-item-section>

              <q-item-section>
                <q-item-label>{{ currentItem.title }}</q-item-label>
                <q-item-label caption lines="2" class="text-grey-7">{{
                  currentItem.message
                }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-card-section>
        </q-card>
      </q-dialog>
    </div>
    <div v-else>No Data Found</div>
  </q-card>
</template>
<script>
import { ref, onMounted, watch } from "vue";
import useAnnouncement from "src/use/announcement";

export default {
  name: "AnnouncementComponent",
  props: {
    symbol: {
      type: String,
      default: "NEPSE",
    },
  },
  components: {},
  setup(props) {
    const { getStockAnnouncement } = useAnnouncement();
    const announcementList = ref([]);
    const dialogAnnouncement = ref(false);
    const currentItem = ref({});

    const getAnnouncementData = (symbol) => {
      getStockAnnouncement(symbol).then((res) => {
        announcementList.value = res.data;
      });
    };

    function showDialog(item) {
      currentItem.value = item;
      dialogAnnouncement.value = true;
    }

    function closeDialog() {
      dialogAnnouncement.value = false;
    }

    onMounted(() => {
      getAnnouncementData(props.symbol);
    });

    watch(props, (newProps, oldProps) => {
      getAnnouncementData(newProps.symbol);
    });

    return {
      announcementList,
      dialogAnnouncement,
      currentItem,
      showDialog,
      closeDialog,
    };
  },
};
</script>
